import { Component,  ElementRef,  EventEmitter,  Input, Output } from '@angular/core';
import { LabelObject } from 'globals/store/events.data';
import { TagPanelData } from 'globals/store/tags.data';
import { PhotoComponent } from 'src/app/components/photo';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { CommonModule } from '@angular/common';
import { TinyTagsComponent } from './tiny-tags.component';
import { LabelTierDialogComponent } from 'src/app/components/label-marker/label-tier.dialog.component';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';


@Component({
    selector: 'tag-popup',
    template: `
<ng-container  *ngIf="{ 
  labels: labelIds | idsToItems:labelMap,
  p: data.performerTags.length,
  r: data.resourceTags.length,
  e: data.exhibitorTags.length,
  s: data.sponsorTags.length,
  w: data.workforceTags.length,
  a: data.attendeeTags.length
 } as n">
  <div class="label-popup" *ngIf="showPopup" [ngClass]="{ 
    showBottom: !popupTop,
    showTop: popupTop
  }" [ngStyle]="{ width: (width || defaultWidth) + 'px'}">
    <ng-container *ngIf="!!labelMap">
      <h5>ACTIVITY LABELS</h5>
      <div class="hint" *ngIf="!n.labels.length">No labels</div>
      <label-tier [labels]="labelIds" [template]="labelMap"></label-tier>
      <hr />
    </ng-container>
    <h5>TAGGED</h5>
    <div class="hint" *ngIf="!(n.p + n.r + n.e + n.s + n.w)">No tags</div>
    <tiny-tags *ngIf="!!n.a" 
      [tags]="data.attendeeTags" 
      [titleIcon]="'ATTENDEES'"
      [entityName]="'Attendee'"
    ></tiny-tags>
    <tiny-tags *ngIf="!!n.w" 
      [tags]="data.workforceTags" 
      [titleIcon]="'workforce'"
      [entityName]="'Worker'"
    ></tiny-tags>
    <tiny-tags *ngIf="!!n.p" 
      [tags]="data.performerTags" 
      [titleIcon]="'performers18'"
      [entityName]="'Performer'"
    ></tiny-tags>
    <tiny-tags *ngIf="!!n.r" 
      [tags]="data.resourceTags" 
      [titleIcon]="'Resources'"
      [entityName]="'Resource'"
    ></tiny-tags>
    <tiny-tags *ngIf="!!n.e" 
      [tags]="data.exhibitorTags" 
      [titleIcon]="'exhibitors_18'"
      [entityName]="'Exhibitor'"
    ></tiny-tags>
    <tiny-tags *ngIf="!!n.s" 
      [tags]="data.sponsorTags" 
      [titleIcon]="'sponsor18'"
      [entityName]="'Sponsor'"
    ></tiny-tags>    
  </div>
  <div class="labels"
    (mouseenter)="openPopup()"
    (mouseleave)="hidePopup.emit()"
    (click)="hidePopup.emit()"
    >
    <ng-container *ngFor="let label of n.labels; first as first; index as i; trackBy: trackByFn">
      <div class="label" *ngIf="i < 4" [ngClass]="{first:first}" 
        [ngStyle]="{zIndex: 5 - i, borderColor: label['color'] ? label['color'] : '', backgroundColor: (0 < i && i < 4) || i === 0 && n.labels.length <= 4 ? (label['color'] || '') : ''}">
        <icon class="more" *ngIf="labelIds?.length > 3 && i === 0" matIcon="more_horiz"></icon>
      </div>
    </ng-container>
    <icon class="more" *ngIf="n.p + n.r + n.e + n.s + n.w > MAX_TAGS" matIcon="more_horiz"></icon>
    <ng-container *ngIf="MAX_TAGS - n.w - n.p - n.r - n.e > 0">
      <photo *ngFor="let tag of data.sponsorTags | slice:0:MAX_TAGS - n.w - n.p - n.r - n.e" [data]="tag" [size]="photoSize"></photo>
    </ng-container>
    <ng-container *ngIf="MAX_TAGS - n.w - n.p - n.r > 0">
      <photo *ngFor="let tag of data.exhibitorTags | slice:0:MAX_TAGS - n.w - n.p - n.r" [data]="tag" [size]="photoSize"></photo>
    </ng-container>
    <ng-container *ngIf="MAX_TAGS - n.w - n.p > 0">
      <photo *ngFor="let tag of data.resourceTags | slice:0:MAX_TAGS - n.w - n.p" [data]="tag" [size]="photoSize"></photo>
    </ng-container>
    <ng-container *ngIf="MAX_TAGS - n.w > 0">
      <photo *ngFor="let tag of data.performerTags | slice:0:MAX_TAGS - n.w" [data]="tag" [size]="photoSize"></photo>
    </ng-container>
    <photo *ngFor="let tag of data.workforceTags | slice:0:MAX_TAGS" [data]="tag" [size]="photoSize"></photo>
  </div>
</ng-container>
`,
    styleUrls: [`./tag-popup.scss`],
    standalone: true,
    imports: [PhotoComponent, LabelTierDialogComponent, IdsToItemsPipe, IconComponent, CommonModule, TinyTagsComponent],
})
export class TagPopupComponent<T extends TagPanelData> {
  @Input() data: T
  @Input() labelIds: string[]
  @Input() labelMap: LabelObject
  @Output() onPopupTop: EventEmitter<boolean> = new EventEmitter()
  @Output() hidePopup: EventEmitter<null> = new EventEmitter()
  @Input() showPopup: boolean = false
  @Input() photoSize = 16
  @Input() topThreshold = 0.7
  @Input() MAX_TAGS = 5
  @Input() width = 0

  defaultWidth = 396
  popupTop = false

  constructor(private elRef: ElementRef) { }

  async openPopup() {
    const el = this.elRef.nativeElement
    console.log({ el, threshold: this.topThreshold })
    this.popupTop= el.getBoundingClientRect().top / window.innerHeight > this.topThreshold // This is not 50% because cannot get this to show outside of schedule lane
    this.onPopupTop.emit(this.popupTop)
  }

  trackByFn(index) {
    return index;
  }
}

